<ng-container *ngIf="!loading">
  <!-- Banner Section Start -->
  <section class="banner overflow-hidden py-3">
    <swiper
      class="home-desktop-banner-swipper hidden md:block"
      [config]="config">
      <ng-template swiperSlide *ngFor="let banner of banners"
        ><a [href]="banner.link">
          <img [src]="banner.path" [alt]="banner.description" />
        </a>
      </ng-template>
    </swiper>
    <swiper class="home-mobile-banner-swipper md:hidden" [config]="config">
      <ng-template swiperSlide *ngFor="let banner of banners">
        <a [href]="banner.link">
          <img
            class="rounded-md"
            [src]="banner.path"
            [alt]="banner.description" />
        </a>
      </ng-template>
    </swiper>
  </section>
  <!-- Banner Section End -->

  <!-- Hot Deals Start -->
  <div class="container mx-auto px-3 py-9">
    <div class="flex items-center justify-between md:justify-center">
      <h2
        class="font-lime-light text-xl font-bold text-secondary-dark md:text-4xl">
        HOT DEALS
      </h2>
      <a
        class="rounded-md bg-gray-100 py-1 px-4 text-sm text-gray-500 hover:bg-gray-200 md:hidden"
        [routerLink]="['/product']"
        [queryParams]="{ sale: true }">
        View All</a
      >
    </div>

    <div class="mt-6 block lg:hidden">
      <swiper class="home-best-seller-swipper" [config]="productConfig">
        <ng-template swiperSlide *ngFor="let product of saleProducts">
          <fc-product-item [product]="product"></fc-product-item>
        </ng-template>
      </swiper>
    </div>

    <div class="mt-6 hidden lg:block">
      <div class="grid grid-cols-6 gap-3">
        <ng-container *ngFor="let product of saleProducts">
          <fc-product-item [product]="product"></fc-product-item>
        </ng-container>
      </div>
    </div>
    <div class="mt-5 hidden justify-center md:flex">
      <a
        class="mx-auto rounded-md bg-gray-100 py-1 px-5 text-lg text-gray-500 hover:bg-gray-200"
        [routerLink]="['/product']"
        [queryParams]="{ sale: true }">
        View All</a
      >
    </div>
  </div>
  <!-- Hot Deals End -->

  <!-- Best Seller Start -->
  <div class="container mx-auto px-3 py-9">
    <div class="flex items-center justify-between md:justify-center">
      <h2 class="font-lime-light text-xl font-bold text-gray-600 md:text-3xl">
        Best Seller
      </h2>
      <a
        class="rounded-md bg-gray-100 py-1 px-4 text-sm text-gray-500 hover:bg-gray-200 md:hidden"
        [routerLink]="['/product']"
        >View All</a
      >
    </div>

    <div class="mt-6 block lg:hidden">
      <swiper class="home-best-seller-swipper" [config]="productConfig">
        <ng-template swiperSlide *ngFor="let product of bestSellerProducts">
          <fc-product-item [product]="product"></fc-product-item>
        </ng-template>
      </swiper>
    </div>

    <div class="mt-6 hidden lg:block">
      <div class="grid grid-cols-5 gap-3">
        <ng-container *ngFor="let product of bestSellerProducts">
          <fc-product-item [product]="product"></fc-product-item>
        </ng-container>
      </div>
    </div>
    <div class="mt-5 hidden justify-center md:flex">
      <a
        class="mx-auto rounded-md bg-gray-100 py-1 px-5 text-lg text-gray-500 hover:bg-gray-200"
        [routerLink]="['/product']"
        >View All</a
      >
    </div>
  </div>
  <!-- Best Seller End -->

  <!-- Beautybook Start -->
  <div class="container mx-auto my-24">
    <div class="mt-6">
      <div class="flex flex-wrap gap-10 lg:gap-20">
        <!-- left section -->
        <div class="mx-auto space-y-5 text-center xl:text-start">
          <div
            class="bg-gradient-to-r from-primary-darkest to-primary-md-dark bg-clip-text font-playfair-display text-5xl leading-tight text-primary-darkest text-transparent">
            BEAUTY <br />
            BOOK
          </div>
          <div class="max-w-md font-semibold text-primary-darkest md:max-w-sm">
            Confused about which lipstick is suitable for you? Try On our
            virtual make up and see the results directly on your selfie!
          </div>
          <div
            class="mx-auto w-1/2 justify-center gap-5 space-y-3 lg:flex lg:w-full lg:justify-between lg:space-y-0">
            <div [routerLink]="'/beautybook/add/1'" class="items-center gap-2">
              <div
                class="cursor-pointer rounded-lg bg-primary-md-dark p-2 px-3 text-lg font-semibold text-white hover:bg-yellow-700">
                Try It On
              </div>
            </div>
            <div
              [routerLink]="'/beautybook/list'"
              class="cursor-pointer rounded-lg border border-primary-md-dark bg-white p-2 px-3 text-lg font-semibold text-primary-md-dark hover:bg-primary-lightest">
              See All Posts
            </div>
          </div>
        </div>
        <!-- end left section -->
        <!-- right section -->
        <div
          class="mx-auto flex flex-wrap content-center justify-center gap-x-9 gap-y-6">
          <ng-container *ngIf="beautybookPosts.length">
            <div
              *ngFor="let post of beautybookPosts.slice(0, 3)"
              class="flex flex-col lg:even:-mt-10">
              <fc-beautybook-item [post]="post"></fc-beautybook-item>
            </div>
          </ng-container>
        </div>
        <!-- end right section -->
      </div>
    </div>
  </div>
  <!-- Beautybook End -->

  <!-- New Arrival Start -->
  <div class="container mx-auto px-3 py-9">
    <div class="flex items-center justify-between md:justify-center">
      <h2 class="font-lime-light text-xl font-bold text-gray-600 md:text-3xl">
        New Arrivals
      </h2>
      <a
        class="rounded-md bg-gray-100 py-1 px-4 text-sm text-gray-500 hover:bg-gray-200 md:hidden"
        [routerLink]="['/product']"
        >View All</a
      >
    </div>

    <div class="mt-6 block lg:hidden">
      <swiper class="home-new-arrival-swipper" [config]="productConfig">
        <ng-template swiperSlide *ngFor="let product of newArrivalProducts">
          <fc-product-item [product]="product"></fc-product-item>
        </ng-template>
      </swiper>
    </div>

    <div class="mt-6 hidden lg:block">
      <div class="grid grid-cols-6 gap-x-3 gap-y-6">
        <ng-container *ngFor="let product of newArrivalProducts">
          <fc-product-item [product]="product"></fc-product-item>
        </ng-container>
      </div>
    </div>
    <div class="mt-5 hidden justify-center md:flex">
      <a
        class="mx-auto rounded-md bg-gray-100 py-1 px-5 text-lg text-gray-500 hover:bg-gray-200"
        [routerLink]="['/product']"
        >View All</a
      >
    </div>
  </div>
  <!-- New Arrival End -->
</ng-container>

<!-- skeleton start -->
<ng-container *ngIf="loading">
  <div class="banner-skeleton container mx-auto px-3 py-9">
    <p-skeleton styleClass="!h-[350px] lg:!h-[300px] w-full"></p-skeleton>
  </div>
  <div class="hot-deals container mx-auto px-3 py-9">
    <div
      class="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      <p-skeleton styleClass="!h-[250px] lg:!h-[300px] w-full"></p-skeleton>
      <p-skeleton styleClass="!h-[250px] lg:!h-[300px] w-full"></p-skeleton>
      <p-skeleton styleClass="!h-[250px] lg:!h-[300px] w-full"></p-skeleton>
      <p-skeleton styleClass="!h-[250px] lg:!h-[300px] w-full"></p-skeleton>
      <p-skeleton styleClass="!h-[250px] lg:!h-[300px] w-full"></p-skeleton>
    </div>
  </div>
</ng-container>

<!-- skeleton end -->
